<div class="table-wrapper">
  <table class="modern-table">
    <thead>
      <tr>
        <th class="checkbox-col">
          <input
            type="checkbox"
            [checked]="isAllSelected()"
            [indeterminate]="isSomeSelected()"
            (change)="toggleSelectAll()">
        </th>
        <th class="sortable" (click)="onSort('created_at')">
          <div class="th-content">
            <span>{{ 'satisfaction.feedbacksTable.dateColumn' | translate }}</span>
            <svg class="sort-icon" [class.active]="sortField === 'created_at'" [class.desc]="sortField === 'created_at' && sortDirection === 'desc'" viewBox="0 0 24 24" width="16" height="16">
              <path d="M7 10l5 5 5-5z" fill="currentColor"/>
            </svg>
          </div>
        </th>
        <th class="sortable" (click)="onSort('queue_name')">
          <div class="th-content">
            <span>{{ 'satisfaction.feedbacksTable.queueColumn' | translate }}</span>
            <svg class="sort-icon" [class.active]="sortField === 'queue_name'" [class.desc]="sortField === 'queue_name' && sortDirection === 'desc'" viewBox="0 0 24 24" width="16" height="16">
              <path d="M7 10l5 5 5-5z" fill="currentColor"/>
            </svg>
          </div>
        </th>
        <th class="sortable" (click)="onSort('score')">
          <div class="th-content">
            <span>{{ 'satisfaction.feedbacksTable.scoreColumn' | translate }}</span>
            <svg class="sort-icon" [class.active]="sortField === 'score'" [class.desc]="sortField === 'score' && sortDirection === 'desc'" viewBox="0 0 24 24" width="16" height="16">
              <path d="M7 10l5 5 5-5z" fill="currentColor"/>
            </svg>
          </div>
        </th>
        <th class="sortable" (click)="onSort('reported_bucket')">
          <div class="th-content">
            <span>{{ 'satisfaction.feedbacksTable.waitPerceptionColumn' | translate }}</span>
            <svg class="sort-icon" [class.active]="sortField === 'reported_bucket'" [class.desc]="sortField === 'reported_bucket' && sortDirection === 'desc'" viewBox="0 0 24 24" width="16" height="16">
              <path d="M7 10l5 5 5-5z" fill="currentColor"/>
            </svg>
          </div>
        </th>
        <th>{{ 'satisfaction.feedbacksTable.commentColumn' | translate }}</th>
        <!-- DEPRECATED (2026-09-08) : colonne "Action" (actions correctives) retirée avec la
             fonctionnalité -- voir la note en tête de satisfaction.component.ts.
        <th>{{ 'satisfaction.feedbacksTable.actionColumn' | translate }}</th>
        -->
        <th>{{ 'satisfaction.feedbacksTable.replyColumn' | translate }}</th>
        <th>{{ 'satisfaction.feedbacksTable.replyDateColumn' | translate }}</th>
        <th>{{ 'satisfaction.feedbacksTable.replyAgentColumn' | translate }}</th>
        <th>{{ 'satisfaction.feedbacksTable.archiveColumn' | translate }}</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngIf="feedbacks.length === 0" class="empty-row">
        <td colspan="10" class="empty-cell">
          {{ 'satisfaction.feedbacksTable.noData' | translate }}
        </td>
      </tr>
      <tr *ngFor="let feedback of feedbacks; trackBy: trackByFeedback" class="table-row">
        <td class="checkbox-col">
          <input
            type="checkbox"
            *ngIf="canSelectFeedback(feedback)"
            [checked]="isSelected(feedback)"
            (change)="toggleSelection(feedback)">
        </td>
        <td class="date-cell">
          <div class="date-wrapper">
            <span class="date-main">{{ formatDateShort(feedback.created_at) }}</span>
            <span class="date-time">{{ formatTime(feedback.created_at) }}</span>
          </div>
        </td>
        <td class="queue-cell">
          <div class="queue-badge" *ngIf="feedback.queue_name">{{ feedback.queue_name }}</div>
          <span class="no-data" *ngIf="!feedback.queue_name">—</span>
        </td>
        <td class="score-cell">
          <div class="score-wrapper" *ngIf="feedback.score; else noScore">
            <div class="stars">{{ getStars(feedback.score) }}</div>
            <span class="score-number">{{ feedback.score }}/5</span>
          </div>
          <ng-template #noScore><span class="no-data">—</span></ng-template>
        </td>
        <td class="wait-time-cell">
          <div class="wait-time-badge" [class]="getWaitTimeClass(feedback.reported_bucket)" *ngIf="feedback.reported_bucket; else noWaitTime">
            {{ getWaitTimeLabel(feedback.reported_bucket) }}
          </div>
          <ng-template #noWaitTime><span class="no-data">—</span></ng-template>
        </td>
        <td class="comment-cell">
          <div class="comment-wrapper" *ngIf="feedback.comment; else noComment">
            <p class="comment-text">{{ feedback.comment }}</p>
          </div>
          <ng-template #noComment><span class="no-data">{{ 'satisfaction.common.noComment' | translate }}</span></ng-template>
        </td>
        <!-- DEPRECATED (2026-09-08) : cellule "Action" (actions correctives) retirée avec la
             fonctionnalité -- voir la note en tête de satisfaction.component.ts.
        <td class="action-cell">
          <div class="actions-group">
            <button
              class="btn-reply"
              [class.has-action]="feedback.has_corrective_action"
              (click)="onCreateAction(feedback)"
              [disabled]="feedback.has_corrective_action"
              [title]="(feedback.has_corrective_action ? 'satisfaction.feedbacksTable.actionCreatedTooltip' : 'satisfaction.feedbacksTable.createActionTooltip') | translate">
              <svg viewBox="0 0 24 24" width="16" height="16">
                <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm5 11h-4v4h-2v-4H7v-2h4V7h2v4h4v2z" fill="currentColor"/>
              </svg>
              <div *ngIf="feedback.has_corrective_action" class="reply-indicator">✓</div>
            </button>
          </div>
        </td>
        -->
        <td class="actions-cell">
          <div class="actions-group">
            <button
              *ngIf="feedback.contact_tel"
              class="btn-reply"
              [class.replied]="feedback.replied_at"
              (click)="onOpenCallModal(feedback)"
              [title]="feedback.replied_at ? getCallTitle(feedback) : ('satisfaction.feedbacksTable.callPatientTooltip' | translate)">
              <svg viewBox="0 0 24 24" width="16" height="16">
                <path d="M6.62 10.79c1.44 2.83 3.76 5.14 6.59 6.59l2.2-2.2c.27-.27.67-.36 1.02-.24 1.12.37 2.33.57 3.57.57.55 0 1 .45 1 1V20c0 .55-.45 1-1 1-9.39 0-17-7.61-17-17 0-.55.45-1 1-1h3.5c.55 0 1 .45 1 1 0 1.25.2 2.45.57 3.57.11.35.03.74-.25 1.02l-2.2 2.2z" fill="currentColor"/>
              </svg>
              <div *ngIf="feedback.replied_at && feedback.contact_method !== 'CLOSED_WITHOUT_CONTACT'" class="reply-indicator">✓</div>
              <div *ngIf="feedback.replied_at && feedback.contact_method === 'CLOSED_WITHOUT_CONTACT'" class="reply-indicator closed">×</div>
            </button>

            <button
              *ngIf="feedback.contact_email && feedback.wants_reply"
              class="btn-reply"
              [class.replied]="feedback.replied_at"
              (click)="onOpenReplyModal(feedback)"
              [title]="feedback.replied_at ? (('satisfaction.feedbacksTable.repliedOnPrefix' | translate) + ' ' + formatDateShort(feedback.replied_at)) : ('satisfaction.feedbacksTable.replyByEmailTooltip' | translate)">
              <svg viewBox="0 0 24 24" width="16" height="16">
                <path d="M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4l-8 5-8-5V6l8 5 8-5v2z" fill="currentColor"/>
              </svg>
              <div *ngIf="feedback.replied_at && feedback.contact_method !== 'CLOSED_WITHOUT_CONTACT'" class="reply-indicator">✓</div>
              <div *ngIf="feedback.replied_at && feedback.contact_method === 'CLOSED_WITHOUT_CONTACT'" class="reply-indicator closed">×</div>
            </button>
          </div>
        </td>
        <td class="reply-date-cell">
          <div class="reply-date-wrapper" *ngIf="feedback.replied_at; else noReplyDate">
            <div class="date-wrapper">
              <span class="date-main">{{ formatDateShort(feedback.replied_at) }}</span>
              <span class="date-time">{{ formatTime(feedback.replied_at) }}</span>
            </div>
          </div>
          <ng-template #noReplyDate><span class="no-data">—</span></ng-template>
        </td>
        <td class="reply-agent-cell">
          <span class="agent-name" *ngIf="feedback.replied_by_name && feedback.replied_by_name.trim(); else noReplyAgent">{{ feedback.replied_by_name }}</span>
          <ng-template #noReplyAgent><span class="no-data">—</span></ng-template>
        </td>
        <td class="archive-cell">
          <button
            *ngIf="feedback.replied_at"
            class="btn-archive"
            (click)="onArchiveFeedback(feedback)"
            [title]="'satisfaction.feedbacksTable.archiveTooltip' | translate">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">
              <polyline points="21,8 21,21 3,21 3,8"/>
              <rect x="1" y="3" width="22" height="5"/>
              <line x1="10" y1="12" x2="14" y2="12"/>
            </svg>
          </button>
          <span class="no-data" *ngIf="!feedback.replied_at">—</span>
        </td>
      </tr>
    </tbody>
  </table>
</div>